export { Banner as banner } from './banner.mjs';
export { Separator as separator } from './separator.mjs';
export { HTML as html } from './html.mjs';
export { Markdown as markdown } from './markdown.mjs';

const VISUALS = ['banner', 'separator', 'html', 'markdown'];

export function isVisual(type) {
	return VISUALS.includes(type);
}
